module.exports = __webpack_public_path__ + "images/design-2f5ec2a64c486de2070209d0e9c7ade7.png";